import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React from "react";
import iconSizes from "../iconSizes";
import { deprecatedPropValueMessage } from "../../../utils/deprecationUtils";
var isDeprecatedIconSize = function(iconSize) {
    if (typeof iconSize === 'undefined') {
        return false;
    }
    return iconSize === 'xl';
};
var CityscapeIcon = function(param) {
    var _size = param.size, size = _size === void 0 ? 's' : _size, _color = param.color, color = _color === void 0 ? 'currentColor' : _color, title = param.title;
    if (isDeprecatedIconSize(size)) {
        deprecatedPropValueMessage({
            componentName: 'Icon',
            propName: 'size',
            propValue: 'xl',
            date: 'Q3 2022'
        });
    }
    var ref;
    return _jsxs("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: '0 0 32 32',
        css: {
            width: iconSizes[size],
            height: iconSizes[size],
            fill: color
        },
        role: "img",
        "aria-hidden": (ref = !title) !== null && ref !== void 0 ? ref : false,
        children: [
            title && _jsx("title", {
                children: title
            }),
            _jsx("g", {
                children: _jsxs("svg", {
                    viewBox: "0 0 24 24",
                    children: [
                        _jsx("path", {
                            d: "M22.59 14.415c-.33-.33-.8-.53-1.27-.53h-.37v-7.67c0-.35-.19-.68-.49-.86a1 1 0 00-.99-.02L13 8.865v-4.74c0-.47-.19-.94-.53-1.27-.34-.34-.79-.53-1.27-.53H5.56c-.47 0-.94.19-1.27.52-.33.33-.53.8-.53 1.27v8.9l-2.59 2.61a.99.99 0 00-.29.71v3.54c0 .24.05.47.14.69.09.22.22.42.39.58a1.81 1.81 0 001.27.53h18.64c.24 0 .47-.05.69-.14.22-.09.42-.22.58-.39.16-.17.3-.36.39-.58.09-.22.14-.45.14-.69v-4.19c0-.48-.19-.93-.53-1.27zm-3.64-6.52v5.99H13v-2.74l5.95-3.25zM11 4.325v15.33H8.66v-3.33c0-.26-.11-.52-.29-.71l-2.6-2.6v-8.69H11zm-4.34 15.34H2.88v-2.92l1.89-1.89 1.89 1.89v2.92zm6.34 0v-3.78h8.12v3.78H13z"
                        }),
                        _jsx("path", {
                            d: "M7.33 7.675h2.1c.55 0 1-.45 1-1s-.45-1-1-1h-2.1c-.55 0-1 .45-1 1s.45 1 1 1z"
                        })
                    ]
                })
            })
        ]
    });
};
CityscapeIcon.isCarinaIcon = true;
export default CityscapeIcon;
